import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISalesItemSimpleListingModel extends IModel {
  salesItemId: number;
  salesItemOptionId: number;
  itemName: string;
  fullName: string;
  optionName: string;
  code: string;
}

export class SalesItemSimpleListingModel
  extends Model
  implements ModelRecord<ISalesItemSimpleListingModel>
{
  salesItemId: number;
  salesItemOptionId: number;
  itemName: string;
  fullName: string;
  optionName: string;
  code: string;

  constructor(params?: Partial<ISalesItemSimpleListingModel>) {
    super(params);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
    this.itemName = defaultTo(params?.itemName, '');
    this.fullName = defaultTo(params?.fullName, '');
    this.optionName = defaultTo(params?.optionName, '');
    this.code = defaultTo(params?.code, '');
  }
}
